import React from 'react';

import { PLATFORM_CONFIG, formatUnreadCount } from 'common-ui/chat/constants';

import {
  ChatBadgesBlock,
  ChatBadgesItem,
  ChatBadgesItemIcon,
  ChatBadgesItemIconBlock,
  ChatBadgesItemIconWrapper,
  ChatBadgesItemNotification,
  ChatBadgesItemTitle,
  NoAccessMessage,
} from './ChatBadges.styles';

const ChatBadges = ({
  permissions,
  platforms = [],
  loading,
  selectedPlatform,
  onPlatformSelect,
}) => {
  const getAllowedPlatforms = () => {
    if (!permissions?.permissions) return [];

    return permissions.permissions
      .filter(
        (perm) => !perm.isDenied && PLATFORM_CONFIG[perm.platform] && perm.platform !== 'gmail'
      )
      .map((perm) => perm.platform);
  };

  const getUnreadCount = (platformId) => {
    const platform = platforms.find((p) => p.id === platformId);
    return platform?.unreadCount || 0;
  };

  const allowedPlatforms = getAllowedPlatforms();

  if (loading) {
    return <ChatBadgesBlock />;
  }

  if (allowedPlatforms.length === 0) {
    return (
      <ChatBadgesBlock>
        <NoAccessMessage>
          You dont have access to any messaging platforms.
          <br />
          Please contact your administrator.
        </NoAccessMessage>
      </ChatBadgesBlock>
    );
  }

  return (
    <ChatBadgesBlock>
      {allowedPlatforms.map((platform) => {
        const config = PLATFORM_CONFIG[platform];
        const isSelected = selectedPlatform === platform;
        const unreadCount = getUnreadCount(platform);

        return (
          <ChatBadgesItem
            key={platform}
            className={isSelected ? 'active' : ''}
            onClick={() => onPlatformSelect(platform)}
          >
            <ChatBadgesItemIconBlock>
              {config.bg ? (
                <ChatBadgesItemIconWrapper $bg={config.bg}>
                  <img src={config.icon} alt={config.name} />
                </ChatBadgesItemIconWrapper>
              ) : (
                <ChatBadgesItemIcon src={config.icon} />
              )}
              {unreadCount > 0 && (
                <ChatBadgesItemNotification className={config.badgeClass}>
                  {formatUnreadCount(unreadCount)}
                </ChatBadgesItemNotification>
              )}
            </ChatBadgesItemIconBlock>
            <ChatBadgesItemTitle>{config.name}</ChatBadgesItemTitle>
          </ChatBadgesItem>
        );
      })}
    </ChatBadgesBlock>
  );
};

export default ChatBadges;
